const bold = 'ExpensifyNeue-Regular';

export default bold;
